import { useEffect } from "react"
import { useLocation } from "react-router-dom"

/**
 * Scrolls the window to the top whenever the route changes inside the portal.
 * Rendered once near the top of the portal tree so each tab navigation starts
 * fresh at the top rather than carrying the previous page's scroll position.
 */
export default function ScrollToTop() {
	const { pathname } = useLocation()

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [pathname])

	return null
}
